import { ActionsUnion, createAction } from 'app/shared/utils/action-helpers';

// Models
import { SarActionTypes } from 'app/modules/fincenSarOld/models';
import { FullSARFilingResponse } from 'app/modules/fincenSAR/responses';
import {
  ArchiveSarPayload,
  CreateSarPayload,
} from 'app/modules/fincenSAR/requests';

// used by goAML to archive
export const archiveSar = (payload: ArchiveSarPayload) => {
  return createAction(SarActionTypes.ARCHIVE_SAR, payload);
};

// success action needed to turn off loading
export const archiveSarSuccess = () => {
  return createAction(SarActionTypes.ARCHIVE_SAR_SUCCESS);
};

export const createSar = (payload: CreateSarPayload) => {
  return createAction(SarActionTypes.CREATE_SAR, payload);
};

export const createNewSar = (
  payload: Omit<CreateSarPayload, 'content' | 'report_type'>,
) => {
  return createAction(SarActionTypes.CREATE_NEW_SAR, payload);
};

// note: this payload is not used to fill in any state
export const createSarSuccess = (payload: FullSARFilingResponse) => {
  return createAction(SarActionTypes.CREATE_SAR_SUCCESS, payload);
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SarActionsList = {
  createSar,
  createSarSuccess,
};

type SarActions = ActionsUnion<typeof SarActionsList>;
export default SarActions;
